module.exports = __webpack_public_path__ + "static/sir-salon-how-93a480e032e3afdd813f1183c2aa73af.jpg";